<template>
  <PageWrapper :isLoading="isLoading">
    <template #title v-if="resourceDetails">
      بخش های منبع {{ resourceDetails.title }}
    </template>
    <template #titleBtn>
      <BButton
        variant="success"
        @click="renderCreateResourceContentSectionDialog"
      >
        افزودن بخش جدید
      </BButton>
    </template>
    <CustomTable
      ref="resourceDetailsTable"
      v-if="resourceDetailsContent"
      :pageNumber="1"
      :count="1"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="resourceDetailsContent"
      :cellDetailsColSpan="5"
      @changePage="() => {}"
    >
      <template #actions="data">
        <div class="d-flex flex-column align-items-center whitespace-nowrap">
          <BButton
            v-if="data.item.attachments && data.item.attachments.length"
            variant="success"
            size="sm"
            @click="renderRowDetails(data.index)"
          >
            مشاهده فایل ها
          </BButton>
          <BButton
            variant="update"
            size="sm"
            class="mt-1"
            @click="renderUpdateResourceDetailSectionDialog(data.item)"
          >
            ویرایش بخش
          </BButton>
          <BButton
            variant="primary"
            size="sm"
            class="mt-1"
            @click="renderAddAttachmentDialog(data.item)"
          >
            افزودن فایل
          </BButton>
          <BButton
            variant="danger"
            size="sm"
            class="mt-1"
            @click="
              renderDeleteResourceDetailDeleteConfirmationDialog(data.item)
            "
          >
            حذف بخش
          </BButton>
        </div>
      </template>
      <template #cellDetails="data">
        <ResourceDetailsAttachmentSection
          :attachmentList="data.item.attachments"
          @refetch="getResourceDetailContent"
        ></ResourceDetailsAttachmentSection>
      </template>
    </CustomTable>
    <AddAttachmentToSectionDialog
      :selectedResourceDetailContent="tempSelectedResourceDetailContent"
      @refetch="getResourceDetailContent"
    >
    </AddAttachmentToSectionDialog>
    <CreateResourceContentSectionDialog
      :resourceDetailId="$route.params.id"
      @refetch="getResourceDetailContent"
    >
    </CreateResourceContentSectionDialog>
    <DeleteResourceDetailContentSectionConfirmationDialog
      :resourceDetailContentSection="tempSelectedResourceDetailContent"
      @refetch="getResourceDetailContent"
    >
    </DeleteResourceDetailContentSectionConfirmationDialog>
    <UpdateResourceDetailSectionDialog
      :resourceDetailContentSection="tempSelectedResourceDetailContent"
      @refetch="getResourceDetailContent"
    ></UpdateResourceDetailSectionDialog>
  </PageWrapper>
</template>

<script>
export default {
  async mounted() {
    await this.getResourceDetail();
    this.getResourceDetailContent();
  },
  data() {
    return {
      isLoading: false,
      resourceDetails: null,
      resourceDetailsContent: null,
      tempSelectedResourceDetailContent: null,
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "نام بخش",
        },
        {
          key: "languageTitle",
          label: "زبان منبع",
        },
        {
          key: "description",
          label: "توضیحات بخش",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    async renderUpdateResourceDetailSectionDialog(tempResourceDetailContent) {
      this.tempSelectedResourceDetailContent =
        await this.createUpdateDtoFromEntity(tempResourceDetailContent);
      this.$bvModal.show("update-resource-detail-section-dialog");
    },
    renderDeleteResourceDetailDeleteConfirmationDialog(
      tempResourceDetailContent
    ) {
      this.tempSelectedResourceDetailContent = tempResourceDetailContent;
      this.$bvModal.show("remove-single-resource-detail-section-from-resource");
    },
    renderCreateResourceContentSectionDialog() {
      this.$bvModal.show("create-resource-content-section-dialog");
    },
    renderAddAttachmentDialog(tempResourceDetailContent) {
      this.tempSelectedResourceDetailContent = tempResourceDetailContent;
      this.$bvModal.show("add-attachment-to-resource-file-section");
    },
    renderRowDetails(rowIndex) {
      if (this.$refs.resourceDetailsTable) {
        this.$refs.resourceDetailsTable.showRowDetails(rowIndex);
      }
    },
    async createUpdateDtoFromEntity(tempResourceDetailContent) {
      return new Promise((resolve, reject) => {
        let tempObject = {
          resourceDetailContentSectionId: tempResourceDetailContent.id,
          title: tempResourceDetailContent.title,
          resourceDetailId: this.resourceDetails.id,
          description: tempResourceDetailContent.description,
          attachments: [
            {
              resourceDetailAttachmentType: 1,
              imageFile: null,
            },
          ],
        };
        resolve(tempObject);
      });
    },
    async getResourceDetail() {
      try {
        this.isLoading = true;
        let _this = this;
        let getResourceDetailsById = new GetResourceDetailsById(_this);
        getResourceDetailsById.setRequestParam({
          resourceDetailId: _this.$route.params.id,
        });
        await getResourceDetailsById.fetch((res) => {
          _this.resourceDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getResourceDetailContent() {
      try {
        this.isLoading = true;
        let _this = this;
        let getResourceDetailsContentById = new GetResourceDetailsContentById(
          _this
        );
        getResourceDetailsContentById.setRequestParam({
          resourceDetailsId: _this.$route.params.id,
        });
        await getResourceDetailsContentById.fetch((res) => {
          _this.resourceDetailsContent = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    DeleteResourceDetailContentSectionConfirmationDialog,
    CreateResourceContentSectionDialog,
    ResourceDetailsAttachmentSection,
    AddAttachmentToSectionDialog,
    UpdateResourceDetailSectionDialog,
    PageWrapper,
    CustomTable,
    BButton,
  },
};
import UpdateResourceDetailSectionDialog from "@/views/components/Resources/ResourceDetails/UpdateResourceDetailSectionDialog.vue";
import DeleteResourceDetailContentSectionConfirmationDialog from "@/views/components/Resources/ResourceDetails/DeleteResourceDetailContentSectionConfirmationDialog.vue";
import CreateResourceContentSectionDialog from "@/views/components/Resources/ResourceDetails/CreateResourceContentSectionDialog.vue";
import AddAttachmentToSectionDialog from "@/views/components/Resources/ResourceDetails/AddAttachmentToSectionDialog.vue";
import ResourceDetailsAttachmentSection from "@/views/components/Resources/ResourceDetails/ResourceDetailsAttachmentSection.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton } from "bootstrap-vue";
import {
  GetResourceDetailsContentById,
  GetResourceDetailsById,
} from "@/libs/Api/Resources";
</script>
